import React, { useCallback, useMemo } from "react";
import Dropdown from "./Dropdown";
import DateRangePicker from "./DateRangePicker";

// Компонент для вибору опцій
const FilterSelector = React.memo(
  ({
    options,
    value,
    onChange,
    placeholder,
    valueKey = "value",
    labelKey = "label",
    type = "select", // 'select', 'text', 'daterange', 'autocomplete'
  }) => {
    // Обробка зміни тексту
    const handleTextChange = useCallback(
      (event) => {
        const newValue = event.target.value;
        onChange(newValue === "" ? null : newValue);
      },
      [onChange]
    );

    // Форматування опцій
    const formattedOptions = useMemo(() => {
      if (!Array.isArray(options)) {
        return [];
      }

      // Перевірка на об'єкт
      return options.map((opt) => {
        if (typeof opt === "object" && opt !== null) {
          return {
            value: String(opt[valueKey]),
            label: String(opt[labelKey] || ""),
          };
        }
        return { value: String(opt || ""), label: String(opt || "") };
      });
    }, [options, valueKey, labelKey]);

    // Відображення відповідного компонента
    switch (type) {
      case "text":
        return (
          <input
            type="text"
            value={value || ""}
            onChange={handleTextChange}
            placeholder={placeholder}
            className="text-input"
          />
        );

      case "select":
        return (
          <Dropdown
            options={formattedOptions}
            selected={value}
            onChange={onChange}
            placeholder={placeholder}
            mode="select"
          />
        );

      case "autocomplete":
        return (
          <Dropdown
            options={formattedOptions}
            selected={value}
            onChange={onChange}
            placeholder={placeholder}
            mode="autocomplete"
          />
        );

      case "daterange":
        return <DateRangePicker value={value} onChange={onChange} />;

      default:
        console.warn(`FilterSelector: Невідомий тип фільтра "${type}"`);
        return null;
    }
  }
);

export default FilterSelector;
